import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { getAnswerType } from '../../visits/components/visitsHelper';
import { SURVEY_ANSWERS_TYPE, SURVEY_QUESTION_CONDITION_TYPE, SURVEY_QUESTION_CONDITION_TYPE_TEXT } from '../../../utils/enums';
import "react-table/react-table.css";

const getConditionDescription = (question, parentAnswerType) => {
    if (parentAnswerType == null) {
        return null;
    }

    if (parentAnswerType.toString() === SURVEY_ANSWERS_TYPE.Bool.toString()) {
        return `Exibir se resposta igual a ${question.subQuestionParentConditionValue === 'false' ? 'Não' : 'Sim'}`;
    }

    if (parentAnswerType.toString() === SURVEY_ANSWERS_TYPE.OptionalDecimal.toString()) {
        const conditionLabel = SURVEY_QUESTION_CONDITION_TYPE_TEXT[question.SubQuestionParentConditionType ?? SURVEY_QUESTION_CONDITION_TYPE.Equals];
        return `Exibir se resposta ${conditionLabel?.toLowerCase()} ${question.subQuestionParentConditionValue}`;
    }

    return null;
};

const renderQuestion = (question, parentAnswerType = null) => {
    const conditionDescription = getConditionDescription(question, parentAnswerType);

    return (
        <div key={`${question.id}-${question.number}`} style={conditionDescription ? { marginLeft: '20px', borderLeft: '3px solid #203ada', paddingLeft: '15px' } : {}}>
            {conditionDescription && <p><b>{conditionDescription}</b></p>}
            <span>{question.number && <b>{question.number})&nbsp;</b>}{question.title}</span>
            <div>
                <p>Tipo de resposta:&nbsp;<span className="main-color">{getAnswerType(question.answerType)}</span></p>
                <p>Palavra-chave IA:&nbsp;<span className="main-color">{question.AIFilterKeywords ? question.AIFilterKeywords : 'Não informado'}</span></p>
                <p>Resposta obrigatória:&nbsp;<span className="main-color">{question.required ? 'Sim' : 'Não'}</span></p>
                <div className='mb-5 flex'>
                    <p>Opções de resposta:&nbsp;</p>
                    <div className='flex mr-3'>
                        {question.answerOptions?.split(";").map((option) => (
                            option ? <p key={`${question.id}-${option}`} className='tag-primary'>{option}</p> : 'Não informado'
                        ))}
                    </div>
                </div>
            </div>

            {(question.conditionalQuestions || []).map((conditionalQuestion) => renderQuestion(conditionalQuestion, question.answerType))}
        </div>
    );
};

const RouteConfirmationModal = ({toggle, isOpen, handleConfirm, campaigns, pointsOfSale, userGroups, distanceFilter, maxDistance, pdvValue, expirationDate, survey, routes}) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-body" centered={true} style={{ maxWidth: '50%' }}>
            <ModalHeader toggle={toggle}>Confirmar Criação de Combo</ModalHeader>
            <ModalBody>
                <p>Confirme os dados antes de prosseguir com o cadastro do Combo:</p>
                <p className='mb-5'><b>Raio:</b> {distanceFilter} metros</p>
                <p className='mb-5'><b>Valor por Ponto de Venda:</b> R${pdvValue}</p>
                <p className='mb-5'><b>Distância máxima:</b> {maxDistance} metros</p>
                <p className='mb-5'><b>Expiração dos combos:</b> {expirationDate && new Date(expirationDate)?.toLocaleDateString("pt-BR")}</p>

                <div className='mb-5 flex'>
                    <b>Pontos de Venda:&nbsp;</b>
                    <div className='flex mr-3'>{pointsOfSale?.map(p => <p className='tag-primary' key={`${p.id}-${p.name}`}>{p.name}</p>)}</div>
                </div>

                <div className='mb-5 flex'>
                    <b>Campanhas:&nbsp;</b>
                    <div className='flex mr-3'>{campaigns?.map(p => <span className='tag-primary' key={`${p.id}-${p.value}`}>{p.label}</span>)}</div>
                </div>
                
                <div className='mb-5 flex'>
                    <b>Grupos de Usuário:&nbsp;</b>
                    <div className='flex mr-3'>{userGroups?.map(p => <p className='tag-primary' key={`${p.id}-${p.value}`}>{p.label}</p>)}</div>
                </div>

                <div className='mb-5'>
                    <b>Questionário:</b>
                    {survey?.map(question => renderQuestion(question))}
                </div>

                <div className='mb-5'>
                    <b>Combos:</b>
                    {routes?.map(route => 
                        <div key={route.id} className='mb-5'>
                            <p>Identificador:&nbsp;<span className="main-color">{route.id}</span></p>
                            <p>Cidade:&nbsp;{route.city}</p>
                            <p>Quantidade de PDVs:&nbsp;{route.pointOfSales.length}</p>
                            <p>Total Km:&nbsp;{route.distanceFix}</p>
                        </div>
                    )}

                </div>
            </ModalBody>

            <ModalFooter className="modal-footer">
                <button className="btn btn-pill btn-danger" type="button" onClick={toggle}>Cancelar</button>
                <button className="btn btn-pill btn-primary btn-air-primary" type="button" onClick={handleConfirm}>Cadastrar</button>
            </ModalFooter>
        </Modal>
    );
}

export default RouteConfirmationModal;